import { Box, TextField } from '@mui/material'
import _ from 'lodash'
import { Controller } from 'react-hook-form'
import { CustomModalTypo } from './StyledTypo'

type PropTypes = {
  control: any
  name: string
  label: string
  errors: any
  fullWidth?: boolean | undefined
  sx?: any | undefined
  type?: string
  rows?: string | number
  multiline?: boolean
  disabled?: boolean
  placeholder?: string
  onClick?: () => void
}

const CustomTextField = ({
  control,
  name,
  label,
  errors,
  sx = {},
  ...rest
}: PropTypes) => (
  <Controller
    control={control}
    name={name}
    render={({ field: { value, onChange } }) => (
      <Box sx={{ width: '100%' }}>
        <CustomModalTypo
          ta={'left'}
          fs={'12px'}
          m={'0px'}
          fw={400}
          lh={'20px'}
          w={'100%'}>
          {label}
        </CustomModalTypo>
        <TextField
          value={value}
          {...rest}
          name={name}
          onChange={(e) => onChange(e.target.value)}
          error={Boolean(_.get(errors, name))}
          sx={{
            maxWidth: !rest.fullWidth ? 500 : 'auto',
            ...sx,
            '& fieldset': {
              border: '1px solid #E6E6E6E6',
              borderRadius: '5px'
            },
            '& .Mui-error': {
              mx: 0
            }
          }}
          helperText={_.get(errors, `${name}.message`)}
        />
      </Box>
    )}
  />
)

export default CustomTextField
